import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class QrReaderService {

  private isScanRequired$ = new Subject<boolean>();

  set scanRequired(required: boolean) {
    this.isScanRequired$.next(required);
  }

  get isScanRequired(): Observable<boolean> {
    return this.isScanRequired$.asObservable();
  }
  
}
